// extracted by mini-css-extract-plugin
module.exports = {"cover":"image_cover__p04Oj","contain":"image_contain__NKbgm"};